/** save a LocalStorage value using context.attributeName as key */
const setLocalStorageValue = (key, value) => {
  const keyPair = key.split(".");
  const context = keyPair[0];
  const attributeName = keyPair[1];
  let localItem = JSON.parse(localStorage.getItem(context)) || {};
  localItem[attributeName] = value;
  localStorage.setItem(context, JSON.stringify(localItem));
};

/** get LocalStorage value using context or context.attributeName */
const getLocalStorageValue = (key) => {
  const keyPair = key.split(".");
  const context = keyPair[0];
  if (keyPair.length === 1) {
    return localStorage.getItem(context);
  }
  const attributeName = keyPair[1];
  let localItem = JSON.parse(localStorage.getItem(context));
  return localItem[attributeName];
};

export { setLocalStorageValue, getLocalStorageValue };
